var normalize = require('normalizr').normalize;
var arrayOf = require('normalizr').arrayOf;
var constants = require('../constants');
var surveySchema = require('../schemas');
var api = require('../../../utils/api');
var commonActions = require('../../common/actions/common');

var Fetch = (function() {

    var _requestSurveys = function() {
        return {
            type: constants.REQUEST_SURVEYS
        };
    }

    var _receiveSurveys = function(data) {
        // compensate data before normalizr
        data.surveys.forEach(function(survey){
            if(!survey.sequence){ // survey with only one question, without `sequence` field; "5506fb3a05bd0b61912acc5d"
                survey.sequence = [{
                    field: survey.fields[0].name,
                    enabled: true
                }];
            }
        });

        // normalizr data
        var normalized = normalize(data, {
            surveys: arrayOf(surveySchema)
        });

        // compensate data after normalizr
        Object.keys(normalized.entities.fields).forEach(function(key){
            var field = normalized.entities.fields[key] || {};
            if(field.type === 'select-belly-pain-region'){
                field.type='select-with-image';
                field.sublabel = "The abdomen is divided into 9 areas, numbered \"1\" through \"9.\" Indicate the areas where you felt your belly pain over the last 7 days. You may select more than one area if you had pain in more than one area.";
                field.imageUrl = "local:image:pain_areas_stomach@2x_v2.png";
                field.choices=[{
                    "label": "Right upper abdomen [1]",
                    "tag": "zone1",
                    "value": 1
                }, {
                    "label": "Upper abdomen [2]",
                    "tag": "zone2",
                    "value": 1
                }, {
                    "label": "Left upper abdomen [3]",
                    "tag": "zone3",
                    "value": 1
                }, {
                    "label": "Right mid abdomen [4]",
                    "tag": "zone4",
                    "value": 1
                }, {
                    "label": "Mid abdomen [5]",
                    "tag": "zone5",
                    "value": 1
                }, {
                    "label": "Left mid abdomen [6]",
                    "tag": "zone6",
                    "value": 1
                }, {
                    "label": "Right lower abdomen [7]",
                    "tag": "zone7",
                    "value": 1
                }, {
                    "label": "Lower abdomen [8]",
                    "tag": "zone8",
                    "value": 1
                }, {
                    "label": "Left lower abdomen [9]",
                    "tag": "zone9",
                    "value": 1
                }];
            }
        });

        return {
            type: constants.RECEIVE_SURVEYS,
            entities: normalized.entities,
            surveys: normalized.result.surveys
        };
    }

    var _fetchSurveysError = function(error) {
        return {
            type: constants.REQUEST_SURVEYS_ERROR,
            errors: error.data
        };
    }

    var _clearSurveysError = function(){
        return {
            type: constants.CLEAR_SURVEYS_ERROR
        }
    }

    var _fetchSurveys = function(surveyIds, accessToken) {
        return function(dispatch) {
            dispatch(_requestSurveys());
            return api.get('/proxy/v1/surveys?id=' + surveyIds, accessToken)
                .then(function(res) {
                    dispatch(_receiveSurveys(res));
                })
                .catch(function(error) {
                    if(error.response){
                        dispatch(_fetchSurveysError(error.response));
                    }else{
                        dispatch(commonActions.setGenericError('', error.message));
                    }
                });
        };
    }

    var _getSurveyIdsWhichNeedFetch = function(dataSurveyIds, surveyIds){
        var surveyIdsWhichNeedFetch = [];
        surveyIds.split(',').forEach(function(surveyId){
            if(dataSurveyIds.indexOf(surveyId) === -1){
                surveyIdsWhichNeedFetch.push(surveyId);
            }
        });
        return surveyIdsWhichNeedFetch.join();
    }

    var _shouldFetchSurveys = function(state, surveyIds) {
        var dataSurveyIds = state.surveys.data;
        if (Object.keys(dataSurveyIds).length === 0) {
            return true;
        } else {
            if(_getSurveyIdsWhichNeedFetch(dataSurveyIds, surveyIds).length > 0){
                return true;
            }else{
                return false;
            }
        }
    }

    var _fetchSurveysIfNeeded = function(surveyIds, accessToken) {
        return function(dispatch, getState) {
            var state = getState();
            if (_shouldFetchSurveys(state, surveyIds)) {
                var dataSurveyIds = state.surveys.data;
                var surveyIdsWhichNeedFetch = _getSurveyIdsWhichNeedFetch(dataSurveyIds, surveyIds);
                return dispatch(_fetchSurveys(surveyIdsWhichNeedFetch, accessToken))
            } else {
                return Promise.resolve();
            }
        }
    }


    return {
        fetchSurveysIfNeeded: _fetchSurveysIfNeeded,
        fetchSurveys: _fetchSurveys,
        clearSurveysError: _clearSurveysError
    }
})();

module.exports = Fetch;



// WEBPACK FOOTER //
// ./src/common/modules/survey/actions/surveys-fetch.js